const randomIntFromInterval = (min, max, round = false) => {
  if (round) {
    return Math.floor(Math.random() * (max - min) + min);
  } else {
    return +(Math.random() * (max - min) + min).toFixed(3);
  }
};

export { randomIntFromInterval };
